import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Notas de Crédito (devoluciones aplicadas a un crédito específico).
 * Habla con /api/credit_note del backend. Servicio NUEVO: no toca user.service.
 */
@Injectable({ providedIn: 'root' })
export class CreditNoteService {

  private baseUrl: string = environment.BASE_LA;

  constructor(private httpClient: HttpClient) { }

  /** Cuentas de pago habilitadas para notas de crédito (tag CREDIT_NOTE). */
  getAccounts = async () => {
    return lastValueFrom(
      this.httpClient.get<any>(`${this.baseUrl}/api/credit_note/accounts`)
    );
  };

  /** Créditos pendientes del cliente, para el selector. */
  getPendingInvoices = async (code_person: string) => {
    return lastValueFrom(
      this.httpClient.get<any>(`${this.baseUrl}/api/credit_note/pending_invoices`, {
        params: { code_person }
      })
    );
  };

  /**
   * Registra la nota de crédito. Va como FormData porque puede llevar el
   * respaldo digital adjunto (imagen o PDF).
   */
  register = async (params: any, archivo: File | null) => {
    const formData = new FormData();
    formData.append('params', JSON.stringify(params));
    if (archivo) formData.append('archivo', archivo);

    return lastValueFrom(
      this.httpClient.post<any>(`${this.baseUrl}/api/credit_note/register`, formData)
    );
  };
}
